/**
 * /en/admin/structure/paragraphs_type/form_element_text/fields
 */

import {ATTRIBUTES} from "../constants/html-constants.es6.js";
import FormElementParagraph from "../paragraphs/form-element-paragraph.es6.js";
import LabelFormElementParagraphField
  from "../fields/form-element-label-paragraph-field.es6.js";
import RegexUtils from "../utils/regex-utils.es6.js";

export default class TextFormElementParagraph extends FormElementParagraph {
  get label() {
    return new LabelFormElementParagraphField({
      machineName: 'field_form_label',
      parentElement: this,
    });
  }

  get minLength() {
    const minLengthString = this.element.$().attr(ATTRIBUTES.MINLENGTH);
    return minLengthString ? Number(minLengthString) : null;
  }

  get maxLength() {
    const maxLengthString = this.element.$().attr(ATTRIBUTES.MAXLENGTH);
    return maxLengthString ? Number(maxLengthString) : null;
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_text',
      parentElement,
    });
  }

  validate(fieldId) {
    const valid = super.validate();
    if (!valid) {
      return false;
    }

    const value = this.value;
    if (value) {
      const minLength = this.minLength;
      if ((minLength || minLength === 0) && value.length < minLength) {
        return false;
      }

      const maxLength = this.maxLength;
      if ((maxLength || maxLength === 0) && value.length > maxLength) {
        return false;
      }
    }

    if (value) {
      switch (fieldId) {
        case 'field-form-element-first-name':
        case 'field-form-element-preferred-nam':
        case 'field-form-element-last-name': {
          return RegexUtils.validateNoNumbers(value);
        }
        case 'field-form-element-zip-code': {
          return RegexUtils.validateOnlyNumberAndDashes(value);
        }
        default:
          return true;
      }
    } else {
      return true;
    }
  }
}
